import {Product, ProductSimple, ProductType, ProductWithVariants} from '@/src/core/domain/entities/product'
import {ProductListItemViewModel, ProductWithVariantsListItemViewModel} from '@/src/presentation'

export const productHasManyVariants = (product: ProductWithVariants) => {
  return (product.variants ?? []).length > 0
}

export const isSimpleProduct = (product: Product): product is ProductSimple => {
  return !('variants' in product)
}

export const isProductWithVariants = (product: Product): product is ProductWithVariants => {
  return product.type === ProductType.WithVariants
}

export const isProductWithCertificate = (product: Product): product is ProductWithVariants => {
  return product.type === ProductType.Certificate
}

export const isProductViewModelWithVariants = (
  productListItemVM: ProductListItemViewModel,
): productListItemVM is ProductWithVariantsListItemViewModel => {
  return !isSimpleProduct(productListItemVM.product)
}
